"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ButtonShare = void 0;
var React = require("react");
var ButtonShare_style_1 = require("./ButtonShare.style");
var Icon_1 = require("../../Icon");
var helpers_1 = require("../../../helpers");
var ButtonClean_1 = require("../../Button/ButtonClean");
var ButtonShare = /** @class */ (function (_super) {
    __extends(ButtonShare, _super);
    function ButtonShare() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ButtonShare.prototype.render = function () {
        var _a = this.props, icon = _a.icon, coins = _a.coins, style = _a.style, onFacebookCtaClick = _a.onFacebookCtaClick, onTwitterCtaClick = _a.onTwitterCtaClick;
        return (React.createElement(ButtonShare_style_1.default.Wrap, { full: this.props.full, style: style },
            React.createElement(ButtonShare_style_1.default.Text, null, this.props.children),
            icon && coins ? (React.createElement(ButtonShare_style_1.default.IconWrap, null,
                React.createElement(Icon_1.default, { icon: icon, size: 22 }),
                React.createElement(ButtonShare_style_1.default.Coins, null, helpers_1.prettifyIfNumber(coins)))) : null,
            React.createElement(ButtonShare_style_1.default.Overlay, null,
                onFacebookCtaClick ? (React.createElement(ButtonClean_1.default, { "aria-label": "Facebook share", onClick: onFacebookCtaClick },
                    React.createElement(Icon_1.default, { icon: "facebook", colorPrimary: "#0b2641", size: 25 }))) : null,
                onTwitterCtaClick ? (React.createElement(ButtonClean_1.default, { "aria-label": "Twitter share", onClick: onTwitterCtaClick },
                    React.createElement(Icon_1.default, { colorPrimary: "#0b2641", icon: "twitter", size: 25 }))) : null)));
    };
    return ButtonShare;
}(React.Component));
exports.ButtonShare = ButtonShare;
exports.default = ButtonShare;
//# sourceMappingURL=ButtonShare.js.map